import React, { useState, useMemo, useCallback } from "react";
import { Menu, ConfigProvider, Row, Col } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import './header-container.scss'

/** Header */
const HeaderContainer = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const screens = useBreakpoint();

    /**
     * 获取适配屏幕的尺寸
     */
    const getAdapterScreenSize = useMemo(() => {
        if (screens.xl || screens.xxl) {
            return {
                menuFontSize: 18,
                itemPaddingInline: 28,
                menuMinWidth: 740,
            }
        }
        if (screens.lg) {
            return {
                menuFontSize: 16,
                itemPaddingInline: 28,
                menuMinWidth: 689,
            }
        }
        if (screens.md) {
            return {
                menuFontSize: 16,
                itemPaddingInline: 16,
                menuMinWidth: 571,
            }
        }
        return  {
            menuFontSize: 14,
            itemPaddingInline: 16,
            menuMinWidth: 0,
        }
    }, [screens])

    const menuItems = useMemo(() => [
        {
            label: '首页',
            key: 'home',
        },
        {
            label: '公司简介',
            key: 'company',
            popupClassName: 'header-popup-sub-menu',
            children: [
                {
                    label: '公司简介',
                    key: 'company#base',
                },
                // TODO: 待放开
                // {
                //     label: '荣誉证书',
                //     key: 'company#honor',
                // },
                {
                    label: '发展历程',
                    key: 'company#milestone',
                },
                {
                    label: '合作伙伴',
                    key: 'company#partner',
                }
            ]
        },
        {
            label: '产品介绍',
            key: 'product',
        },
        // {
        //     label: '案例展示',
        //     key: 'case_show',
        // },
        {
            label: '新闻中心',
            key: 'news_center',
            popupClassName: 'header-popup-sub-menu',
            children: [
                {
                    label: '新闻资讯',
                    key: 'news_center/news',
                },
                {
                    label: '行业动态',
                    key: 'news_center/dynamic',
                }
            ],
        },
        {
            label: '联系我们',
            key: 'contact',
        },
    ], [])
    const location = useLocation();
    const currentPath = location.pathname;
    const currentPathName = currentPath.replace(/^\//, '');
    const navigate = useNavigate();
    const handleMenuClick = (e) => {
        setIsMenuOpen(false);
        navigate(`/${e.key}`);
    }

    /** 菜单按钮点击 */
    const handleMenuBtnClick = useCallback(() => {
        setIsMenuOpen(!isMenuOpen)
    }, [isMenuOpen])

    return (
        <div className="header-container">
            <Row className="header-content">
                <Col xs={0} sm={0} md={24} lg={24} xl={24}>
                    <div className="header-web-container">
                        <div className="header-company-name">TOYONIA</div>
                        <div className="header-menu-container">
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: '#FFFFFF', // 选中态
                                        colorText: '#FFFFFF', // 未选中态
                                        fontSize: getAdapterScreenSize.menuFontSize,
                                    },
                                    components: {
                                        Menu: {
                                            popupBg: '#04808080',
                                            itemSelectedBg: '#048080E6',
                                            itemSelectedColor: '#FFFFFF',
                                            itemActiveBg: '#048080E6',
                                            dropdownWidth: 'auto',
                                            itemPaddingInline: getAdapterScreenSize.itemPaddingInline,
                                        },
                                    }
                                }}
                            >
                                <Menu
                                    selectedKeys={currentPathName}
                                    mode="horizontal"
                                    items={menuItems}
                                    onClick={handleMenuClick}
                                    className="header-menu"
                                    style={{
                                        minWidth: getAdapterScreenSize.menuMinWidth,
                                    }}
                                />
                            </ConfigProvider>
                        </div>
                    </div>
                </Col>
                <Col xs={24} sm={24} md={0} lg={0} xl={0}>
                    <div className="header-mobile-container">
                        <div className="header-company-name">TOYONIA</div>
                        <div className="header-menu-btn" onClick={handleMenuBtnClick}>
                            <MenuOutlined />
                        </div>
                    </div>
                </Col>
            </Row>
            {
                isMenuOpen ? (
                    <ConfigProvider
                        theme={{
                            token: {
                                colorPrimary: '#FFFFFF', // 选中态
                                colorPrimaryBg: '#FFFFFF', // 选中态，背景色
                                colorText: '#FFFFFF', // 未选中态
                            },
                            components: {
                                Menu: {
                                    itemSelectedBg: '#048080E6',
                                    itemSelectedColor: '#FFFFFF',
                                    itemActiveBg: '#048080E6',
                                },
                            }
                        }}
                    >
                        <Menu
                            selectedKeys={currentPathName}
                            mode="inline"
                            items={menuItems}
                            onClick={handleMenuClick}
                            className="header-menu-mobile"
                        />
                    </ConfigProvider>
                ) : null
            }
        </div>
    )
}

export default HeaderContainer;